var swal = require('sweetalert2');
var AjaxController = require('../../services/AjaxController');

/**
 * Helper
 */
var helper = require('../../helper');

$(function() {

    var $datatable = $('#datatable-payments-active'),
        columns = [
            {data: 'first_name', name: 'guardian.user.first_name', className : "data-export"},
            {data: 'last_name', name: 'guardian.user.last_name', className : "data-export"},
	        {data: 'mobile_number', name: 'guardian.user.mobile_number', visible: false, className : "data-export"},
            {data: 'fee', name: 'fee', className : "data-export"},
            {data: 'room_name', name: 'room.name', className : "data-export"},
            {data: 'due_date', name: 'due_date', type: 'nullable', className : "data-export"},
            {data: 'date_start', name: 'date_start', className : "data-export"},
            {data: 'outstanding_amount', name: 'outstanding_amount', className : "data-export"},
            {data: 'payment_status', name: 'payment_status', orderable: false, searchable: false, className : "data-export"},
            {data: 'status', name: 'status', orderable: false, searchable: false, className : "data-export"},
            {data: 'property_name', name: 'room.property.name', className : "data-export"},
	        {data: 'notes', name: 'guardian.notes', className : "data-export"},
	        {data: 'bank_account', name: 'bank_account', className : "data-export"},
            {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action"}
        ],
        dataTables_buttons = [
		{
			extend: 'csv',
			text: 'Export as CSV',
			exportOptions: {
				columns: '.data-export',
			},
		},
		{
			extend: 'pdf',
			text: 'Export as PDF',
			exportOptions: {
				columns: '.data-export',
			},
			orientation: 'landscape'
		},
        {
            extend: 'print',
            text: 'Print table',
            exportOptions: {
	            columns: '.data-export',
            }
        },
		{
			extend: 'colvis',
		}
	],
    $dt;

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/rents/payments/active",
            "method": 'POST',
            "data": function ( d ) {
                d.payment_status_id = $('input[name="clickedStatusId"]').val();
                d.overdue = $('input[name="overdue"]').val();
            }
        },
	    "buttons": dataTables_buttons,
        "bAutoWidth" : false,
        "order": [[ 4, "asc" ]],
	    'columnDefs': [{
		    'targets': 11,
		    'className': 'dt-body-center tiny-column',
		    'render': function (data, type, full, meta){
                if (data[2] !== null && data[3] !== null) {
                    return '<textarea id="notes-'+data[0]+'" rows="5" cols="75" type="text" name="notes[]" ' +
                        'class="js-guardians-change-field" data-guardian='+data[0]+' data-field="notes" ' +
                        'data-firstname='+data[4]+' data-lastname='+data[5]+'>'+data[1]+'</textarea>' +
                        '<span class="pull-left" style="font-size: smaller;"><i>Last edited by '+ data[2] +' at '+ data[3] +'</i></span>';
                } else {
                    return '<textarea id="notes-'+data[0]+'" rows="5" cols="75" type="text" name="notes[]" ' +
                        'class="js-guardians-change-field" data-guardian='+data[0]+' data-field="notes" ' +
                        'data-firstname='+data[4]+' data-lastname='+data[5]+'>'+data[1]+'</textarea>' +
                        '<span class="pull-left" style="font-size: smaller;"><i>Last edited by</i></span>';
                }
		    }
	    },
	    ],
        "columns": columns
    });

    $('.js-payments-activity-box').on('click', function() {
        var $this = $(this),
            $clickedStatusId = $('input[name="clickedStatusId"]'),
            $overdueField = $('input[name="overdue"]'),
            paymentStatusId = $(this).data('payment_status_id'),
            overdue = $(this).data('overdue');

        $clickedStatusId.val(paymentStatusId);
        $overdueField.val(overdue);

        $dt.ajax.reload();
    });

    $dt.on('click', 'td', function () {
        var old = $(this).html();
        var cell = $dt.cell(this);

        $(document).on('change', '.js-guardians-change-field', function(e){

            var $this = $(this);
            var guardianId = $this.data('guardian'),
                field = $this.data('field'),
                value = $this.val(),
                firstname = $this.data('firstname'),
                lastname = $this.data('lastname');

            var url = '/api/guardians/change-field-on-guardian';

            var data = {
                field: field,
                guardianId: guardianId,
                value: value
            };
            var success = function (response) {
                console.log('Success');
            }
            var error = function (response) {
                console.log('Error');
            }

            e.preventDefault();

            swal({
                title: "Are you sure you want to save changes for guardian "+firstname+ " "+lastname+ "?",
                text: "",
                type: "warning",
                showCancelButton: true
            }).
            then(function (result) {
                if (result.value) {
                    AjaxController.prototype.send(url, data, success, error);
                    cell.data(data).draw();
                } else {
                    cell.data(old).draw();
                }
            })
        });
    });
});
